import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
var swiper = new Swiper('.swiper', {
    modules: [Autoplay],
    loop: true,
    slidesPerView: 1,
    speed: 8000,
    breakpoints: {
        560: {
            speed: 20000
        }
    },
    allowTouchMove: false,
    autoplay: {
        delay: 0
    }
});
